import { TextField } from '@mui/material';
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

import { Autocomplete } from '@occc/ui-design-system';


import { OfferTableType } from '../../../../tobacco-api-offers.types';
import { useBrandAutocomplete } from './use-brand-autocomplete.hook';

type BrandAutocompleteProps = {
  tableType: OfferTableType;
  isOpen: boolean;
  value: string;
  onChange: (brand: string) => void;
};

export const BrandAutocomplete = ({ tableType, isOpen, value, onChange }: BrandAutocompleteProps) => {
  const { options, selectedOption, searchInput, loading, error, handleChange, handleInputChange } =
    useBrandAutocomplete({ tableType, isOpen, selectedBrand: value, onBrandChange: onChange });

  return (
    <Autocomplete
      options={options}
      value={selectedOption}
      inputValue={searchInput}
      onInputChange={handleInputChange}
      filterOptions={(opts) => opts}
      onChange={handleChange}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          id={`${tableType}-filter-brand`}
          name={`${tableType}-brand`}
          label='Category'
          placeholder='Type to search'
          size='small'
          error={!!error}
          helperText={error ? 'Failed to load categories' : undefined}
        />
      )}
      size='small'
      fullWidth
      loading={loading}
      disabled={!!error}
    />
  );
};
